import { render, staticRenderFns } from "./YeniKotasyonFormu.vue?vue&type=template&id=149bcf58"
import script from "./YeniKotasyonFormu.vue?vue&type=script&lang=js"
export * from "./YeniKotasyonFormu.vue?vue&type=script&lang=js"
import style0 from "./YeniKotasyonFormu.vue?vue&type=style&index=0&id=149bcf58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports